import statuses from '@/helpers/statuses'

const initialState = () => ({
  received: [],
  sent: [],
  countNew: 0,
  meta: {
    loadingReceived: statuses.IDLE,
    loadingSent: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    receivedMessages: state => state.received,
    receivedLoading: state => state.meta.loadingReceived,
    isReceivedLoading: state => state.meta.loadingReceived === statuses.LOADING,

    sentMessages: state => state.sent,
    sentLoading: state => state.meta.loadingSent,
    isSentLoading: state => state.meta.loadingSent === statuses.LOADING,

    countNewMessages: state => state.countNew
  },

  mutations: {
    fetchReceivedMessages: state => {
      state.meta.loadingReceived = statuses.LOADING
    },

    fetchReceivedMessagesSuccess: (state, messages) => {
      state.meta.loadingReceived = statuses.LOADED
      state.received = messages
    },

    fetchReceivedMessagesFailure: state => {
      state.meta.loadingReceived = statuses.FAILED
    },

    fetchSentMessages: state => {
      state.meta.loadingSent = statuses.LOADING
    },

    fetchSentMessagesSuccess: (state, messages) => {
      state.meta.loadingSent = statuses.LOADED
      state.sent = messages
    },

    fetchSentMessagesFailure: state => {
      state.meta.loadingSent = statuses.FAILED
    },

    updateCountNew: (state, count) => {
      state.countNew = count
    },

    updateSeen: (state, { id, seenAt }) => {
      const message = state.received.find(p => p.id === id)
      if (message) {
        message.seenAt = seenAt
      }
    },

    resetMessages: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchReceivedMessages: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchReceivedMessages')
      try {
        const result = await api.fetchReceivedMessages(slug)
        commit('fetchReceivedMessagesSuccess', result)
      } catch (error) {
        commit('fetchReceivedMessagesFailure', error)
      }
    },

    fetchSentMessages: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchSentMessages')
      try {
        const result = await api.fetchSentMessages(slug)
        commit('fetchSentMessagesSuccess', result)
      } catch (error) {
        commit('fetchSentMessagesFailure', error)
      }
    },

    fetchCountNewMessages: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      const { count } = await api.fetchCountNewMessages(slug)
      commit('updateCountNew', count)
    },

    seenMessage: async ({ commit }, id) => {
      const slug = api.getWorkspaceSlug()
      const { seenAt } = await api.seenMessage(slug, id)
      commit('updateSeen', { id, seenAt })
    },

    sendMessage: async ({ commit }, data) => {
      const slug = api.getWorkspaceSlug()
      await api.sendMessage(slug, data)
    },

    clear: ({ commit }) => {
      commit('resetMessages')
    }
  }
})
